import React from 'react';
import { Palette, Database, Monitor, Search } from 'lucide-react';
import { whatYouveBeenSent, images } from '../../data/mock';

const WhatSentSection = () => {
  const features = [
    { icon: Palette, ...whatYouveBeenSent.includes[0] },
    { icon: Database, ...whatYouveBeenSent.includes[1] },
    { icon: Monitor, ...whatYouveBeenSent.includes[2] },
    { icon: Search, ...whatYouveBeenSent.includes[3] }
  ];

  return (
    <section className="bg-black text-white">
      {/* Main Content - Image Left, Text Right */}
      <div className="grid lg:grid-cols-2 min-h-[600px]">
        {/* Image */}
        <div className="relative min-h-[400px] lg:min-h-full">
          <img
            src={images.dashboard}
            alt="Dashboard preview"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>

        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 lg:px-12 xl:px-20 py-16 lg:py-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium leading-tight mb-8">
            {whatYouveBeenSent.title}
          </h2>
          <p className="text-lg text-white/70 leading-relaxed mb-12 max-w-lg">
            {whatYouveBeenSent.intro}
          </p>

          {/* Features List */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-10 h-10 bg-accent-orange/20 flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-5 h-5 text-accent-orange" />
                </div>
                <div>
                  <p className="font-medium mb-1">{feature.title}</p>
                  <p className="text-sm text-white/60">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Note Bar */}
      <div className="bg-white/5 py-6 px-6 lg:px-12 text-center">
        <p className="text-white/60 text-sm">{whatYouveBeenSent.note}</p>
      </div>
    </section>
  );
};

export default WhatSentSection;
